<template functional>
    <div class="event-summary__event-media">
        <!-- <div class="event-summary__event-media-icon">
            <i
                class="icon--md icon-live_indicator"
                :class="props.liveBetting ? 'active' : 'inactive'">
            </i>
        </div> -->
        <div
            v-if="props.liveVideo"
            class="event-summary__event-media-icon"
        >
            <Tooltip :text="parent.$t('Live video stream avaliable')">
                <i class="icon icon-live_stream" />
            </Tooltip>
        </div>
        <div
            v-if="props.liveSound"
            class="event-summary__event-media-icon"
        >
            <i
                class="actionable icon icon-audio_stream"
            >
            </i>
        </div>
        <div
            v-if="props.broadcast"
            class="event-summary__event-media-icon"
        >
            <div class="broadcasts">
                <div class="brodacst__header">
                    <span>{{ parent.$t('Watch match on TV')}}</span>
                </div>
                <div
                    class="broadcasts__item"
                    v-for="(channel, index) in props.broadcast.channels"
                    :key="index"
                >
                    <div
                        class="broadcasts__item-image"
                        :style="{'background-image': 'url(' + `/static/img/channels/${channel.logo}.png` + ')'}"
                    ></div>
                    <span class="broadcasts__item-text">
                        {{ channel.name }}
                    </span>
                </div>
            </div>
            <i
                class="actionable icon icon-tv"
            >
            </i>
        </div>
    </div>
</template>

<script>

    export default {
        functional: true,
        props: {
            liveSound: {
                type: Boolean,
                required: true,
            },
            liveVideo: {
                type: Boolean,
                required: true,
            },
            liveBetting: {
                type: Boolean,
                required: true,
            },
            broadcast: {
                type: Object,
                default: null,
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/terminal/app/modules/shared/event/EventMediaWidget.vue